/**
 * A wrapper for session storage with error handling
 * Wraps session storage gets, sets and removes and saves and parses objects instead of strings
 * Allows use of serialized objects
 */
namespace appn.sessionStorage {
    /**
     * Gets an object from sessionstorage
     * @param key
     */
    export function getItem(key: string): any {
        let item = null;

        try {
            const ssValue: any = window.sessionStorage.getItem(key);
            item = ssValue ? JSON.parse(ssValue) : null;
        } catch (e: any) {
            if (e && e.message)
                console.log(e.message);
        }

        return item;
    }

    /**
     * Creates or Updates an object in sessionstorage
     * @param key
     * @param value
     */
    export function setItem(key: string, value: any) {
        let isSet = true;

        try {
            window.sessionStorage.setItem(key, JSON.stringify(value));
        } catch (e: any) {
            isSet = false;
            if (e && e.message)
                appn.log.error(e.message, true);
        }

        return isSet;
    }

    /**
     * Removes an object from sessionstorage
     * @param key
     */
    export function removeItem(key: string) {
        try {
            window.sessionStorage.removeItem(key);
        } catch (e: any) {
            if (e && e.message)
                console.log(e.message);
        }
    }

    /**
     * Clears EVERYTHING out of session storage
     */
    export function clearAll() {
        try {
            window.sessionStorage.clear();
        } catch (e: any) {
            if (e && e.message)
                console.log(e.message);
        }
    }
}
